/**
 * Centralized user-facing labels for Pronto.
 *
 * Per regola interna (dopo il drift "Messaggi multipli" / "WhatsApp a tutti"
 * scoperto in iter 72), tutte le label di feature multi-touchpoint vivono qui.
 * Modifica in UN solo posto → propagazione automatica.
 *
 * Convention: SCREAMING_SNAKE_CASE per la chiave, stringa user-facing italiana.
 */

// Bulk WhatsApp greetings — sidebar, modal title, dashboard CTA, contatti toolbar, landing
export const BULK_GREETINGS_LABEL = "Messaggi WhatsApp";
export const BULK_GREETINGS_LABEL_LONG = "Messaggi WhatsApp a tutti";
export const BULK_GREETINGS_HINT = "Auguri di gruppo per festività · 1 messaggio personalizzato per ogni cliente";

// Pagina annuncio (vs "pagina pubblica" in legalese — solo Terms.jsx)
export const PUBLIC_LISTING_LABEL = "Pagina annuncio";
